<template>
<div v-view.once="inViewport" class="row dealeritem">
  <transition name="fade" >
    <div class="m" v-bind:id="'dealerview-' + index">
      <div>
      <div class="col-md-3 col-sm-3 col-xs-3">
        <div class="raute"><p><b>{{index + 1}}</b></p></div>
      </div>
      <div class="col-md-18 col-sm-18 col-xs-18">

        <p>
          <b>{{dealer.firma}}</b>
          <br>{{dealer.strasse}} <br>{{dealer.postleitzahl}} {{dealer.ort}}
        </p>
          <br>
        <div style="display:block; min-height:38px;">

          <div v-if="dealer.vermieter=='True'" class="ui large label">
          <i class="icon"><font-awesome-icon icon="stopwatch" /></i>{{$t('Vermietung')}}
          </div>
          <div v-if="dealer.haendler=='True'" class="ui large label">
            <i class="icon"><font-awesome-icon icon="warehouse" /></i>{{$t('Verkauf')}}
          </div>
          <div v-if="dealer.servicepartner=='True'" class="ui large label">
            <i class="icon"><font-awesome-icon icon="wrench" /></i>{{$t('Servicepartner')}}
          </div>
        </div>
        <div class="more" @click="expand()">
          <font-awesome-icon v-bind:icon="!showdetails ? 'chevron-down': 'chevron-up'" class="big icon"  style="transform: scale(1.4);"/>
        </div>
      </div>
      <div class="col-md-3 col-sm-3 col-xs-3" style="min-width:40px; padding-left: 10px; padding-right: 5px;">
        <div><b style="color: #c51a1b;">{{Math.round(dealer.distance)}} km</b></div>
        <br>
          <img v-if="dealer.tophaendler=='True'" src="https://www.rewaco.com/assets/images/top-haendler.png" class="re-top-dealer" style="float: left; margin-right: 20px;">
      </div>
    </div>

      <div class="col-md-24 col-sm-24 col-xs-24 nopadding">
        <DealerDetailView :show="showdetails" :dealer="dealer"></DealerDetailView>
      </div>

    </div>

</transition>

</div>
</template>

<script>
import DealerDetailView from './DealerDetailView'


export default {
  name: 'DealerPreview',
  props: ['dealer','showDealerLink','index','showBookmark'],
  data: function() {
    return {
      body: "",
      disabled: true,
      imageUrl: null,
      showdetails: false
    }
  },
  components: {
    DealerDetailView
  },
  created: function() {
      this.showdetails = false;
  },
  watch: {
    dealer(newValue, oldValue) {
    this.showdetails =  false;
    }
  },
  beforeDestroy () {
  },
  methods: {

    expand: function(){
      this.showdetails = !this.showdetails;
    },
    activate: function(){
      this.showdetails = true;
    },
    deactivate: function(){
      this.showdetails = false;
    },
    inViewport: function (e) {

    },
    openDetailPage: function(vehicleid, directcontact= false){

      this.$emit('selected', directcontact)

    }
  }
}
</script>

<style scoped>

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.nopadding{
  padding-left: 0px;
  padding-right: 0px;
}


.raute {
    position: absolute;
    width: 40px;
    height: 40px;
    left: 0;
    background-image: url('https://www.rewaco.com/typo3conf/ext/site_base/Resources/Public/images/mapmarker.svg');
    top: 0;
}

.raute p {
    width: 100%;
    text-align: center;
    line-height: 32px;
    color: white;
}

.icon-label{
  width: 100%;
  text-align: center;
  line-height: 32px;
  color: white;
  z-index: 2;
}

.more{
  width: 100%;
  text-align: center;
}
.dealeritem{
  border-bottom: 1px solid rgba(34,36,38,.15);
  padding-bottom: 20px;
  padding-top: 16px;
}
</style>
